import { Router } from 'express';
import { AuthService } from '../services/auth-service.js';
import { ApiError } from '../types.js';

export const authRouter = Router();
const authService = new AuthService();

// 用户登录
authRouter.post('/login', async (req, res, next) => {
  try {
    const { username, password } = req.body;
    
    if (!username || !password) {
      throw new ApiError(400, 'Username and password are required');
    }

    const result = await authService.login(username, password);
    
    res.success({
      user: result.user,
      token: result.token
    });
  } catch (error) {
    if (error instanceof Error && error.message === '用户名或密码错误') {
      next(new ApiError(401, error.message));
    } else {
      next(error);
    }
  }
});

// 用户登出
authRouter.post('/logout', async (req, res, next) => {
  try {
    const token = req.headers.authorization?.replace('Bearer ', '');
    
    if (token) {
      await authService.logout(token);
    }
    
    res.success({ message: 'Logged out successfully' });
  } catch (error) {
    next(error);
  }
});

// 获取当前用户信息
authRouter.get('/me', async (req, res, next) => {
  try {
    const token = req.headers.authorization?.replace('Bearer ', '');
    
    if (!token) {
      throw new ApiError(401, 'No authorization token provided');
    }

    const user = await authService.getCurrentUser(token);
    
    if (!user) {
      throw new ApiError(401, 'Invalid or expired token');
    }
    
    res.success(user);
  } catch (error) {
    next(error);
  }
});

// 验证 token（用于检查登录状态）
authRouter.post('/verify', async (req, res, next) => {
  try {
    const { token } = req.body;
    
    if (!token) {
      throw new ApiError(400, 'Token is required');
    }

    const user = await authService.validateToken(token);
    
    if (!user) {
      throw new ApiError(401, 'Invalid or expired token');
    }
    
    res.success({
      valid: true,
      user
    });
  } catch (error) {
    next(error);
  }
});

// 刷新 token（延长会话）
authRouter.post('/refresh', async (req, res, next) => {
  try {
    const token = req.headers.authorization?.replace('Bearer ', '');
    
    if (!token) {
      throw new ApiError(401, 'No authorization token provided');
    }

    const user = await authService.validateToken(token);
    
    if (!user) {
      throw new ApiError(401, 'Invalid or expired token');
    }
    
    // 生成新 token
    const result = await authService.login(user.username, '123456'); // 临时方案
    
    res.success({
      token: result.token,
      user: result.user
    });
  } catch (error) {
    next(error);
  }
});

// 定期清理过期会话
setInterval(async () => {
  try {
    await authService.cleanupExpiredSessions();
  } catch (error) {
    console.error('Error cleaning up sessions:', error);
  }
}, 60 * 60 * 1000); // 每小时清理一次